import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import i18n from '../../i18n';
import { CurrencyFormatter } from '../../utils/Intl';

import Conversation from '../../models/Conversation';
// import Transfert from '../../models/Transfert';
import User from '../../models/User';

export class ExchangeTotal extends React.Component {
    static propTypes = {
        currency: PropTypes.string.isRequired,
        conversation: PropTypes.instanceOf(Conversation).isRequired,
        // transferts: PropTypes.arrayOf(PropTypes.instanceOf(Transfert)),
        user: PropTypes.instanceOf(User).isRequired
    };

    render() {
        const { currency, conversation, user } = this.props;
        const exchange = conversation.getExchange();
        const exchangeAsGuest = conversation.getExchangeAsGuest();
        const total = conversation.getGpBalance();

        // guest subscriber subscription not expired
        const guestSubscriber = exchange.get('guest').id == user.id && user.isSubscriber();

        const totalToPay = exchange.getTotalToPay(guestSubscriber);

        let gpText;
        if (exchange.getMissingFields().length > 0) {
            // missing informations, can't calculate the total
            gpText = null;
        } else if (total === 0 && exchange.get('host').id == user.id) {
            // exchange is free -> host view
            gpText = '0 GP';
        } else if (total === 0 && exchange.get('guest').id == user.id) {
            // exchange is free -> guest view
            gpText = i18n.t('exchange:free');
        } else if (total > 0) {
            // user will earn GP with this exchange
            gpText = <span className="gp-earn">+{total} GP</span>;
        } else {
            // user will lose GP with this exchange
            gpText = <span className="gp-give">{total} GP</span>;
        }

        let priceText;
        if (exchangeAsGuest && totalToPay > 0) {
            priceText = CurrencyFormatter.format(totalToPay, currency);
        }
        return (
            <span>
                {gpText}
                {gpText && priceText && ' / '}
                {priceText}
            </span>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        transferts: state.transferts
    };
}

export default connect(mapStateToProps)(ExchangeTotal);
